
<div :class="customClass">
  <!-- <span class="px-1"> • </span> -->
  {{ formattedElapsedTime }}
</div>
